module.exports = __webpack_public_path__ + "static/media/CleverMedia_Romania.0604d278.png";